module.exports = __webpack_public_path__ + "img/mitsubishi.9048b321.jpg";